import { ToggleGroup } from "radix-ui";
import type { ReactNode } from "react";

import styles from "./Segmented.module.css";
import { cx } from "../lib/cx";

export type SegmentedOption = {
  readonly label: ReactNode;
  readonly value: string;
};

export type SegmentedProps = {
  readonly "aria-label"?: string;
  readonly className?: string;
  readonly disabled?: boolean;
  readonly onValueChange: (value: string) => void;
  readonly options: ReadonlyArray<SegmentedOption>;
  readonly value: string;
};

export const Segmented = ({
  "aria-label": ariaLabel,
  className,
  disabled,
  onValueChange,
  options,
  value,
}: SegmentedProps) => (
  <ToggleGroup.Root
    aria-label={ariaLabel}
    className={cx(styles.seg, className)}
    disabled={disabled}
    onValueChange={(next) => {
      if (next) {
        onValueChange(next);
      }
    }}
    type="single"
    value={value}
  >
    {options.map((o) => (
      <ToggleGroup.Item className={styles.btn} key={o.value} value={o.value}>
        {o.label}
      </ToggleGroup.Item>
    ))}
  </ToggleGroup.Root>
);
